var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ViewChild } from '@angular/core';
import { Point } from '../../diagram/utils/common/point';
import { ConfigureComponentBase } from '../../../../shared/configure-component-base';
var ElementSettingModalBase = /** @class */ (function (_super) {
    __extends(ElementSettingModalBase, _super);
    function ElementSettingModalBase(injector, modelDivId) {
        var _this = _super.call(this, injector) || this;
        _this.active = false;
        _this.saving = false;
        _this.locationX = 0;
        _this.locationY = 0;
        _this.fixedPositionType = 0;
        _this.modelDivId = modelDivId;
        return _this;
    }
    ElementSettingModalBase.prototype.init = function (editedComponent) {
        this.loadComponentInfo(editedComponent.model);
        this.loadLocationInfo(editedComponent.model);
        this.loadFixedPositionType(editedComponent.model);
    };
    /**
   * tab selected
   * @param eventName : event name
   * @param configureId? : current configure id
   */
    ElementSettingModalBase.prototype.tabSelected = function (eventName, configureId) {
        if (configureId !== undefined && configureId !== 0) {
            abp.event.trigger(eventName, configureId);
        }
        else {
            abp.event.trigger(eventName);
        }
    };
    /**
     * load component info
     * @param component : current edited component
     */
    ElementSettingModalBase.prototype.loadComponentInfo = function (editedComponent) {
        // save current diagram for update node data property
        this.currentDiagram = editedComponent.diagram;
        this.currentEditedPartData = editedComponent.data;
    };
    /**
     * load location info
     * @param component : current edited component
     */
    ElementSettingModalBase.prototype.loadLocationInfo = function (editedComponent) {
        if (editedComponent.location) {
            this.locationX = Number(editedComponent.location.x);
            this.locationY = Number(editedComponent.location.y);
        }
    };
    ElementSettingModalBase.prototype.loadFixedPositionType = function (editedComponent) {
        if (editedComponent.fixedPositionType >= 0) {
            this.fixedPositionType = editedComponent.fixedPositionType;
        }
    };
    /**
     * save location info
     */
    ElementSettingModalBase.prototype.saveLocationInfo = function () {
        this.saveComponentProperty('loc', new Point(this.locationX, this.locationY).toString());
    };
    ElementSettingModalBase.prototype.saveFixedPositionType = function () {
        this.saveComponentProperty('fixedPositionType', this.fixedPositionType);
    };
    /**
     * save edited component property, to make it work on diagram
     * @param property
     * @param value
     */
    ElementSettingModalBase.prototype.saveComponentProperty = function (property, value) {
        this.currentDiagram.model.setDataProperty(this.currentEditedPartData, property, value);
    };
    /**
     * delete property in current edited component
     * @param propertyName : property name
     */
    ElementSettingModalBase.prototype.deleteComponentProperty = function (propertyName) {
        delete this.currentEditedPartData[propertyName];
    };
    ElementSettingModalBase.prototype.show = function (editedComponent) {
        this.active = true;
        this.modal.show();
        if (this.modelDivId) {
            $("#" + this.modelDivId + " .modal-content").draggable({
                cursor: 'pointer',
                handle: '.modal-header',
                containment: 'body',
                scroll: false
            });
        }
        this.init(editedComponent);
    };
    ElementSettingModalBase.prototype.close = function () {
        this.modal.hide();
    };
    ElementSettingModalBase.prototype.onHidden = function () {
        this.active = false;
        this.saving = false;
        this.dynamicValidatoinResult = false;
    };
    __decorate([
        ViewChild('settingModal', { static: true })
    ], ElementSettingModalBase.prototype, "modal", void 0);
    return ElementSettingModalBase;
}(ConfigureComponentBase));
export { ElementSettingModalBase };
